export default "__VITE_ASSET__a7095fd7__"